
var xDown = null;
var yDown = null;

function getTouches(evt) {
    return evt.touches ||
           evt.originalEvent.touches;
}

function handleTouchStart(evt) {
    const firstTouch = getTouches(evt)[0];
    xDown = firstTouch.clientX;
    yDown = firstTouch.clientY;
};

function handleTouchMove(evt, props) {

    let eventTarget;
    if(evt.path) {
            eventTarget = evt.path;
    }
    else {
            eventTarget = evt.targetTouches;
    }        
  
     let localName = [];

            // if the asertation of context fails, just execute the swipe as if 
            // no table was found. 
            try {
                    if(evt.path) {
                        // android    
                        for (let x of eventTarget) {
                            localName.push(x.localName.toLowerCase())
                        }
                    }
                    else {
                        // iphone - get the parent and parent of parent nodes as swiping on 
                        // text returns a p or b tag. This way we look up the dom to see if there are any table elements
                        for (let x of eventTarget) {
                            localName.push(x.target.localName.toLowerCase())
                            localName.push(x.target.parentNode.nodeName.toLowerCase())
                            localName.push(x.target.parentNode.parentNode.nodeName.toLowerCase())
                        }
                    }    
            }
            catch {}

        // tags that should stop page swiping
        let tableTags = ['table','td','tr']; 
        
        if(!localName.some(r=> tableTags.indexOf(r) >= 0)) {

             if (!xDown || !yDown) {
                 return;
             }
    
            var xUp = evt.touches[0].clientX;
            var yUp = evt.touches[0].clientY;
    
            var xDiff = xDown - xUp;
            var yDiff = yDown - yUp;
    
            if (Math.abs(xDiff) + Math.abs(yDiff) > 80) { //added to fix swipe sensitivity
    
            if (Math.abs(xDiff) > Math.abs(yDiff)) {
                if (xDiff > 0) {
                    props.nextQuestion()
                    /* left swipe */
                } else {
                    props.previousQuestion()
                    /* right swipe */
                }
            } else {
                if (yDiff > 0) {
                    /* up swipe */
                } else {
                    /* down swipe */
                }
            }
                /* reset values */
                xDown = null;
                yDown = null;
            }

    }
};

export { getTouches, handleTouchMove, handleTouchStart }